import { useRequest } from '@polvo-labs/react-auth'
import React, { useRef, useState } from 'react'
import { FieldRenderProps } from 'react-final-form'
import { toast } from 'react-toastify'
import { Upload } from '../../Chat/type'
import Icon from '../../Icon'
import Loader from '../../Loader'
import { AvatarButton, AvatarImage } from './styles'

interface Props extends FieldRenderProps<Upload, HTMLInputElement> {
  id: string
}

const Avatar: React.FC<Props> = ({
  id,
  input,
}) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const [uploading, setUploading] = useState(false)
  const { request } = useRequest()

  const uploadFile = (event: any) => {
    const files = Array.from(event.target.files as FileList)
    if (files.length > 0) {

      if (files.some(f => f.size > 20000000)) {
        toast.error('Arquivo não deve exceder 20MB de tamanho.')
        return
      }

      setUploading(true)

      const formData = new FormData()
      files.forEach(file => {
        formData.append('files[]', file)
      })

      request({
        method: 'POST',
        url: `${process.env.REACT_APP_API_URL}/uploads`,
        data: formData,
      }).then(({ data }) => {
        setUploading(false)
        if (data && data.data) {
          input.onChange(data.data[0])
        }
      }).catch(() => {
        toast.error('Ocorreu um erro ao fazer o upload')
        setUploading(false)
      })
    }
  }

  const deleteAvatar = (evt: any) => {
    if (evt.target.id === "deleteAvatarButton" || evt.target.src.includes("/static/media/delete")) {
      evt.preventDefault()
      input.onChange({ "id": null, "url": null, "tiny": "https:\/\/iptu-core-api.s3.amazonaws.com\/assets\/img\/person\/placeholder_tiny.png", "small": "https:\/\/iptu-core-api.s3.amazonaws.com\/assets\/img\/person\/placeholder_small.png", "medium": "https:\/\/iptu-core-api.s3.amazonaws.com\/assets\/img\/person\/placeholder.png", "large": "https:\/\/iptu-core-api.s3.amazonaws.com\/assets\/img\/person\/placeholder.png" }
      )
    }
    // setUploading(true)
    // request({
    //   method: 'DELETE',
    //   url: `${process.env.REACT_APP_API_URL}/uploads/${input.value.id}`,
    // }).then(({ data }) => {
    //   setUploading(false)
    //   if (data && data.data) {
    //     input.onChange(null)
    //   }
    // }).catch(() => {
    //   toast.error('Ocorreu um erro ao fazer o upload')
    //   setUploading(false)
    // })
  }

  return (
    <>
      <input
        id={id}
        ref={inputRef}
        type="file"
        accept="image/jpeg,image/jpg,image/png"
        onChange={uploadFile}
        hidden
      />

      <label
        role="button"
        htmlFor={id}
        style={{
          alignSelf: 'center',
        }}
      >
        {input.value ? (<>
          <AvatarImage>
            <img
              src={input.value.small}
              alt="User avatar"
            />
          </AvatarImage>
          {input.value.id && (<div style={{ marginTop: '-30px', marginLeft: '130px', height: '16px', width: '16px', cursor: 'pointer' }} id="deleteAvatarButton" onClick={(evt: any) => { deleteAvatar(evt) }}><Icon
            name="delete"
          /></div>)}
        </>
        ) : (
            <AvatarButton>
              <Icon
                name="camera"
              />
            </AvatarButton>
          )}
      </label>



      {uploading && (
        <Loader
          full
        />
      )}
    </>
  )
}

export default Avatar
